// Bundled, read-only demo dataset (L0-U10 session 2, ADR 0031). Rendered
// client-side on the /demo page so a prospective user can see what a populated
// journal looks like without importing anything. It is STRUCTURALLY isolated:
// nothing here is ever written to the real tenant — the demo page reads this
// module directly and issues no mutations. Money values are decimal strings to
// match the app's wire format (formatMoney/formatPrice consume strings).

export interface DemoSummary {
  netPnl: string;
  winRate: number; // 0..1
  profitFactor: number;
  totalTrades: number;
  avgWin: string;
  avgLoss: string;
}

export interface DemoTrade {
  id: string;
  symbol: string;
  side: "long" | "short";
  openedOn: string; // ISO date (YYYY-MM-DD)
  closedOn: string;
  pnl: string; // signed decimal string
  rMultiple: number;
}

export interface DemoDataset {
  summary: DemoSummary;
  // Cumulative account equity over the demo window; used for the sparkline.
  equityCurve: readonly number[];
  trades: readonly DemoTrade[];
}

export const DEMO_DATASET: DemoDataset = {
  summary: {
    netPnl: "4187.50",
    winRate: 0.62,
    profitFactor: 2.14,
    totalTrades: 42,
    avgWin: "318.40",
    avgLoss: "-172.90",
  },
  equityCurve: [
    10000, 10180, 10090, 10410, 10620, 10550, 10880, 11120, 10960, 11240,
    11510, 11430, 11790, 12080, 11950, 12260, 12540, 12410, 12780, 13050,
    13420, 13310, 13680, 14010, 14187.5,
  ],
  trades: [
    {
      id: "demo-1",
      symbol: "AAPL",
      side: "long",
      openedOn: "2026-05-04",
      closedOn: "2026-05-04",
      pnl: "412.00",
      rMultiple: 2.3,
    },
    {
      id: "demo-2",
      symbol: "TSLA",
      side: "short",
      openedOn: "2026-05-05",
      closedOn: "2026-05-06",
      pnl: "-188.50",
      rMultiple: -1.0,
    },
    {
      id: "demo-3",
      symbol: "NVDA",
      side: "long",
      openedOn: "2026-05-07",
      closedOn: "2026-05-07",
      pnl: "639.25",
      rMultiple: 3.1,
    },
    {
      id: "demo-4",
      symbol: "SPY",
      side: "long",
      openedOn: "2026-05-08",
      closedOn: "2026-05-11",
      pnl: "204.75",
      rMultiple: 1.2,
    },
    {
      id: "demo-5",
      symbol: "AMD",
      side: "short",
      openedOn: "2026-05-12",
      closedOn: "2026-05-12",
      pnl: "-156.00",
      rMultiple: -0.9,
    },
    {
      id: "demo-6",
      symbol: "MSFT",
      side: "long",
      openedOn: "2026-05-13",
      closedOn: "2026-05-14",
      pnl: "287.30",
      rMultiple: 1.6,
    },
    {
      id: "demo-7",
      symbol: "META",
      side: "long",
      openedOn: "2026-05-15",
      closedOn: "2026-05-15",
      pnl: "521.00",
      rMultiple: 2.7,
    },
    {
      id: "demo-8",
      symbol: "QQQ",
      side: "short",
      openedOn: "2026-05-18",
      closedOn: "2026-05-18",
      pnl: "-203.40",
      rMultiple: -1.1,
    },
  ],
};
